export function initializeFlickity() {

    const reviewsCarousels = document.querySelectorAll('.reviews-carousel');

    reviewsCarousels.forEach(carousel => {
        new Flickity(carousel, {
            cellAlign: 'left',
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            autoPlay: 3500,
            pauseAutoPlayOnHover: true,
            wrapAround: true
        });
    });
    

    const heroSliders = document.querySelectorAll('.hero-slider-main');

    heroSliders.forEach(slider => {
        new Flickity(slider, {
            cellAlign: 'center',
            wrapAround: true,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: 4000
        });
    });

    const heroVariantSliders = document.querySelectorAll('.hero-slider-variant');

    heroVariantSliders.forEach(slider => {
        new Flickity(slider, {
            cellAlign: 'center',
            wrapAround: true,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: 4000
        });
    });

}